module.exports = __webpack_public_path__ + "static/media/Chandra.98e04de2.png";